var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_14965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 24H0V0H18V24Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9391 12.5953C14.9297 10.875 15.7078 9.57656 17.2828 8.62031C16.4016 7.35938 15.0703 6.66563 13.3125 6.52969C11.6484 6.39844 9.82969 7.5 9.16406 7.5C8.46094 7.5 6.84844 6.57656 5.58281 6.57656C2.96719 6.61875 0.1875 8.6625 0.1875 12.8203C0.1875 14.0484 0.4125 15.3172 0.8625 16.6266C1.4625 18.3469 3.62812 22.5656 5.8875 22.4953C7.06875 22.4672 7.90312 21.6563 9.44062 21.6563C10.9312 21.6563 11.7047 22.4953 13.0219 22.4953C15.3 22.4625 17.2594 18.6281 17.8312 16.9031C14.775 15.4641 14.9391 12.6844 14.9391 12.5953ZM12.2859 4.89844C13.5656 3.37969 13.4484 1.99688 13.4109 1.5C12.2812 1.56563 10.9734 2.26875 10.2281 3.13594C9.40781 4.06406 8.925 5.2125 9.02813 6.50625C10.2516 6.6 11.3672 5.97188 12.2859 4.89844Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_14965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.20dae52658d17e3f160695197719539f.svg";
export { ForwardRef as ReactComponent };